export const formatDate = (date: Date) => {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear()
  ].join('/');
};

const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, '0');
};

export const setDateToTheEndOfTheDay = (d?: Date) => {
  if (d) {
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
  } else {
    d = new Date();
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
  }

  return d;
};
